<template>
  <strong
    class="strong-label"
    :class="{
      'strong-label--small': size === 'small',
      'strong-label--large': size === 'large',
      'strong-label--danger': kind === 'danger',
      'strong-label--success': kind === 'success',
    }"
  >
    <slot />
  </strong>
</template>

<script>
export default {
  name: 'StrongLabel',
  props: {
    kind: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
};
</script>
<style lang="scss">
.strong-label {
  font-size: $global-font-size;

  &--success {
    color: $green-sea;
  }

  &--danger {
    color: $alizarin;
  }

  &--small {
    font-size: $global-font-size * 1.5;
  }

  &--large {
    font-size: $global-font-size * 2;
  }
}
</style>
